// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".auth-load-spinner{position:absolute;top:40%;left:50%}", "",{"version":3,"sources":["webpack://./node_modules/@timeedit/ui-components/lib/src/components/AuthWrapper/AuthWrapper.scss"],"names":[],"mappings":"AAAA,mBACE,iBAAA,CACA,OAAA,CACA,QAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
